import React, { PropTypes } from 'react';

import ReactDOM from 'react-dom';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  NitroHeading,
  NitroText,
  NitroParagraph,
  NitroDivider,
  NitroButtonGroup,
  NitroButton,
  NitroIcon,
  NitroLoading
} from 'nitro-components';

import styled from 'styled-components';

import * as actions from './actions';

import { media } from 'style-utils';

const MainContainer = styled.div`
   width: 100%;
   flex-basis: 24.2%;
   width: ${props => (props.minVersion ? '24%' : '100%')};
   margin: ${props => (props.minVersion ? '10px 0px' : '0px 0px')};
   margin-right: ${props => (props.minVersion ? '1%' : '0px')};
   border:${props => (props.minVersion ? '1px solid' : '0px')};
   border-color : ${props => (props.minVersion ? props.theme.color.border : 'none')};
   box-shadow:${props => (props.minVersion ? '0 2px 4px 0 rgba(0,0,0,0.15)' : 'none')};
   border-radius: 2px;
   background: ${props => props.theme.color.white};

   &:nth-of-type(4n) {
    margin-right: 0px;
  }

  ${media.tablet`
     flex-basis: 49%;
     margin-right:  ${props => (props.minVersion ? '2%' : '0px')};
     &:nth-of-type(2n) {
      margin-right: 0px;
    }
  `}

   ${media.mobile`
     flex-basis: 100%;
     margin-right: 0px;
  `}
`;

const Container = styled.div`

  height:  ${props => (props.minVersion ? '105px' : props.containerHeight)};

  >div {
     padding: ${props => (props.minVersion ? '15px 20px 20px 20px' : '20px 0px 5px 0px')};

  }

  ${media.mobileTablet`
    height: auto;
  `}
`;

const Content = styled.section`
  margin: ${props => (props.minVersion ? '10px 0 0 0' : '15px 0 10px 0')};
  width: 100%;
  max-height: 40px;
  cursor: pointer;
  overflow: hidden;
`;

const TimeStamp = styled.section`
  float: right;
`;

const DeleteContainer = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
  margin-left: 10px;
  opacity: 0.8;
  transition: opacity .3s;

  &:hover {
    opacity: 1;
  }
`;

const DeleteConfirmation = styled.section``;

const ReportName = styled.section`
  background: ${props => props.theme.color.base3};
  border-radius: 100px;
  display: inline-block;
  padding: 0 10px;
`;

const CategoryName = ReportName.extend`
  background: ${props => props.theme.color.base2};
`;

const LeftContainer = styled.section`
  width: ${props => (!props.condensed && props.deleteVisible ? '70%' : '100%')};
  float:  ${props => (!props.condensed && props.deleteVisible ? 'left' : 'none')};
  display: ${props => (props.deleteVisible && props.deleteFullWidth ? 'none' : 'inline-block')};
`;

const Divider = styled.section`
  margin: 0 10px;
  display: inline-block;
`;

const RightContainer = styled.section`
  float: right;
  text-align: ${props => (props.deleteFullWidth ? 'center' : 'right')}
`;

class NotificationMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteConfirmation: false,
      elemHeight: 0
    };
    this.toggleDeleteConfirmation = this.toggleDeleteConfirmation.bind(this);
    this.getHeight = this.getHeight.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.deleteComplete !== this.props.deleteComplete &&
      !this.props.deleteInProgress
    ) {
      this.state = {
        showDeleteConfirmation: false
      };
      // this.props.actions.getNotifications();
      this.props.onDelete();
    }
  }

  /**componentWillReceiveProps(nextProps) {
    if (nextProps.resetConfirm !== this.props.resetConfirm) {
      this.state = {
        showDeleteConfirmation: false
      };
    }
  }**/

  toggleDeleteConfirmation = () => {
    this.setState({
      showDeleteConfirmation: !this.state.showDeleteConfirmation
    });
  };

  confirmDelete = keys => {
    const data = {
      NotificationIds: keys,
      Status: 1 //1-> delete 2-> read
    };
    // this.props.onDelete(data);
    this.props.actions.deleteNotification(data);
  };

  getHeight = element => {
    if (element && this.state.elemHeight === 0) {
      // need to check that we haven't already set the height or we'll create an infinite render loop
      this.setState({ elemHeight: element.clientHeight });
    }
  };

  render() {
    const {
      title,
      timeStamp,
      description,
      condensed,
      displayDeleteFullWidth,
      minVersion,
      keys,
      keyId,
      reportParam,
      deleteInProgress,
      categoryName
    } = this.props;
    return (
      <MainContainer minVersion={minVersion}>
        <div>
          <Container
            condensed={condensed}
            minVersion={minVersion}
            containerHeight={this.state.elemHeight + 'px'}
          >
            <div ref={this.getHeight}>
              {deleteInProgress && <NitroLoading />}
              {!deleteInProgress &&
                <div>
                  <LeftContainer
                    deleteVisible={this.state.showDeleteConfirmation}
                    deleteFullWidth={displayDeleteFullWidth}
                  >
                    {title &&
                      <span>
                        <ReportName>
                          <NitroText size="5" variant="white" bold>
                            {title}
                          </NitroText>
                        </ReportName>
                        <Divider>
                          <NitroIcon
                            name="arrow-right"
                            size="8"
                            right={6}
                            variant="base3"
                          />
                        </Divider>
                      </span>}
                    <CategoryName>
                      <NitroText size="5" variant="white" bold>
                        {categoryName}
                      </NitroText>

                    </CategoryName>
                    <RightContainer>
                      {!this.state.showDeleteConfirmation &&
                        <TimeStamp>
                          <NitroText size="5" variant="base3" noMargin>
                            {timeStamp}
                          </NitroText>
                          <DeleteContainer
                            onClick={this.toggleDeleteConfirmation}
                          >
                            <NitroIcon
                              name="delete"
                              size="12"
                              right={6}
                              variant="base3"
                              hoverVariant="base2"
                            />
                          </DeleteContainer>
                        </TimeStamp>}
                    </RightContainer>

                    <Content onClick={() => this.props.onClick(reportParam)}>
                      <NitroParagraph
                        size="3"
                        variant="notification"
                        bold
                        noMargin
                      >
                        {description}
                      </NitroParagraph>
                    </Content>
                  </LeftContainer>
                  {this.state.showDeleteConfirmation &&
                    <div ref={this.updateHeight}>
                      <DeleteConfirmation>
                        <NitroHeading
                          size="4"
                          variant="base2"
                          bold
                          label="Delete notification ?"
                          align={displayDeleteFullWidth ? 'center' : 'right'}
                        />
                        <NitroButtonGroup
                          layout="horizontal"
                          inline
                          align={displayDeleteFullWidth ? 'center' : 'right'}
                        >
                          <NitroButton
                            size="extraSmall"
                            label="Yes, delete"
                            variant="notification"
                            action={() => this.confirmDelete(keys)}
                          />
                          <NitroButton
                            size="extraSmall"
                            label="Cancel"
                            action={this.toggleDeleteConfirmation}
                          />
                        </NitroButtonGroup>
                      </DeleteConfirmation>
                    </div>}

                </div>}
            </div>
          </Container>
        </div>
        {!this.props.minVersion && <NitroDivider noMargin noTopPad />}
      </MainContainer>
    );
  }
}

NotificationMessage.propTypes = {
  title: PropTypes.string,
  timeStamp: PropTypes.string,
  description: PropTypes.string,
  keys: PropTypes.array,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  reportParam: PropTypes.object,
  resetConfirm: PropTypes.bool,
  deleteInProgress: PropTypes.bool,
  condensed: PropTypes.bool,
  minVersion: PropTypes.bool,
  displayDeleteFullWidth: PropTypes.bool,
  categoryName: PropTypes.string,
  actions: PropTypes.object,
  deleteInProgress: PropTypes.bool,
  deleteComplete: PropTypes.bool
};

const mapStateToProps = state => ({
  deleteInProgress: state.globalNotification.deleteInProgress,
  deleteComplete: state.globalNotification.deleteComplete
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  NotificationMessage
);



// WEBPACK FOOTER //
// ./src/features/common/GlobalNotification/NotificationMessage.js